import {detailServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = detailServicesPath + '/organizations/fittings'

export default class FittingsController {
    static async getAll() {
        return axios.get(restUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(moduleId, data) {
        return await axios.post(restUrl + "?moduleId=" + moduleId, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(id, data) {
        return await axios.put(restUrl + '/' + id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id);
    }
}